export default {
  activationButton: 'Activate Account'
}
